import { AfterContentChecked, AfterViewInit, Component, Input } from '@angular/core';
import { Notification } from '@portals/api';
import { environment } from '@portals/environments';

@Component({
	selector: 'notification-preview-modal',
	templateUrl: './notification-modal.component.html',
	styleUrls: ['./notification-modal.component.scss'],
})
export class NotificationModalComponent implements AfterContentChecked {
	app = environment.app;
	maxChar = false;
	@Input() notification!: Notification;

	constructor() {}

	ngAfterContentChecked() {
		if (String(this.notification?.channel?.name).length >= 20) {
			this.maxChar = true;
		}
	}
}
